export const all = () => {
    return [
        {
            key: "GOV",
            value: 1,
            labelRef: 'CIVIL',
        },
        {
            key: 'PRIVATE',
            value: 3,
            labelRef: 'PRIVATE',
        },
        {
            key: 'OTHER',
            value: 4,
            labelRef: 'OTHER',
        },
    ]
}

export const getValueByKey = (key) => {
    return all().find(item => item.key === key)?.value
}

export const getLabelRefByKey = (key) => {
    return all().find(item => item.key === key)?.labelRef
}

export const getLabelRefByValue = (value) => {
    return all().find(item => item.value === value)?.labelRef
}

export default {
    all,
    getValueByKey,
    getLabelRefByKey,
    getLabelRefByValue,
};